import React, { useEffect } from "react";
import { withRouter } from "./_shared/withRouter";
import Loader from "./_shared/loader";
import AlertComponent from "./_shared/alert";
import { commonAppApi } from "./actions/commonActions";
import Router from "./router";

let myInterval;

const App = () => {

  useEffect(() => {
  
    callBasicApi();
  
  }, []);

  const callBasicApi = async () => {
    try {
      await commonAppApi();
    } catch (error) {
      // commonAppApi already handles its own errors; this is a safety net so a
      // failed app-init fetch never surfaces as an uncaught runtime error.
    }
  };

  const checkClickEvent = () => {
    clearTimeout(myInterval);   
  };

  return (
    <React.Fragment>
      <Loader />
      <AlertComponent />
      <div onClick={checkClickEvent}>
        <Router />
      </div>
    </React.Fragment>
  );
};

export default withRouter(App);
